import { isAndroid } from '@/utils/constants-platform-specific';

export type RaceToPlaceAmountSelectorType = 'quick-amounts' | 'number-pad';

// Animation
export const HEIGHT_DURATION = 200;

// Amount selector dimensions
export const QUICK_AMOUNTS_HEIGHT = 36;
export const INPUT_HEIGHT = isAndroid ? 70 : 64;
export const KEYBOARD_HEIGHT = 196;

// Label heights
export const ERROR_CONTENT_HEIGHT = 20;
export const TO_WIN_CONTENT_HEIGHT = 20;

// Layout dimensions
export const RACE_TO_PLACE_LOBBY_MARGIN_TOP = 40;
export const RACE_TO_PLACE_MODAL_MARGIN_TOP = 48;
export const RACE_TO_PLACE_ACTION_BUTTON_HEIGHT = 44;
export const RACE_TO_PLACE_FILL_METER_HEIGHT = 36;
export const RACE_TO_PLACE_LOBBY_HEIGHT = 203;
export const RACE_TO_PLACE_MODAL_SHEET_TITLE_HEIGHT = 24;
export const RACE_TO_PLACE_BOTTOM_SEPARATOR_HEIGHT = 17;

// Card internal layout
export const LIST_PADDING_TOP = 16;
export const LIST_SEPARATOR_HEIGHT = 1;
export const CARD_BOTTOM_PADDING = 16;
export const CARD_BORDER_WIDTH = 1;
export const SHEET_BOTTOM_PADDING = 16;

// Config
export const DEFAULT_QUICK_AMOUNTS = [5, 10, 25];

// Spacing between elements
export const spacing = {
    SELECTOR_TO_ERROR: 8,
    SELECTOR_TO_TO_WIN: 16,
    SELECTOR_TO_BUTTON: 16, // When no labels visible in quick-amounts mode
    ERROR_TO_KEYBOARD: 12,
    ERROR_TO_BUTTON: 16,
    TO_WIN_TO_BUTTON: 16,
    KEYBOARD_TO_BUTTON: 16,
    INPUT_TO_KEYBOARD: 16,
} as const;
